import React from "react";
import CampusDashboard from "../superadmin/CampusDashboard";

function ControllerCampusAnalyticsPage({ onLogout, showToast, students }) {
  return (
    <CampusDashboard
      onLogout={onLogout}
      showToast={showToast}
      students={students}
      analyticsOnly
    />
  );
}

export default ControllerCampusAnalyticsPage;
